export const APP_STR = 'whss'
